import React from 'react';
import {
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Rating,
} from '@mui/material';
import { useHotels } from '../hooks/useApi';

const HomePage: React.FC = () => {
  const { hotels, loading } = useHotels();

  return (
    <Box>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Horwath HTL
        </Typography>
        <Typography
          variant="h5"
          component="h2"
          color="text.secondary"
          gutterBottom
        >
          Leading hospitality consulting services worldwide
        </Typography>
        <Button variant="contained" size="large" sx={{ mt: 2 }}>
          Learn More
        </Button>
      </Box>

      <Grid container spacing={4} sx={{ mb: 6 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h3" gutterBottom>
                Consulting Services
              </Typography>
              <Typography color="text.secondary">
                Expert hospitality consulting to help your business thrive in
                the competitive market.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h3" gutterBottom>
                Market Research
              </Typography>
              <Typography color="text.secondary">
                Comprehensive market analysis and research to inform your
                strategic decisions.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h3" gutterBottom>
                Global Expertise
              </Typography>
              <Typography color="text.secondary">
                Decades of experience in hospitality markets across the globe.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Featured Hotels Section */}
      <Box sx={{ mt: 8 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ textAlign: 'center', mb: 4 }}
        >
          Featured Properties
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={4}>
            {hotels.map(hotel => (
              <Grid item xs={12} md={4} key={hotel.id}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" component="h3" gutterBottom>
                      {hotel.name}
                    </Typography>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>
                      {hotel.city}, {hotel.country}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Rating
                        value={hotel.rating}
                        readOnly
                        precision={0.1}
                        size="small"
                      />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {hotel.rating}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2 }}
                    >
                      {hotel.description}
                    </Typography>
                    <Typography variant="h6" color="primary">
                      ${hotel.priceRange.min} - ${hotel.priceRange.max}/night
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default HomePage;
